<template lang="pug">
  form#createKeyResult.card.max-w-sm.w-full(v-if="keyResult" class="sm:rounded-b-none sm:rounded-t-xl sm:p-8" @submit.prevent="createKeyResult")
    
    .flex.justify-between.items-baseline
      label Key Result title 
      .text-gray-5.font-normal.text-xs required
    input.p-2.krTitle(v-focus v-model="keyResult.title" :class="{ error: keyResultError }")
    .error-text(v-if="keyResultError") {{keyResultError}}

    label.mt-2 What’s the target value?
    input.p-2.krTarget(v-model="keyResult.targetValue")
    
    label.mt-2 What’s the value right now?
    input.p-2.krInitial(v-model="keyResult.initialValue")

    label.mt-2 What’s the unit of measurment?
    input.p-2.krUnit(v-model="keyResult.unit" placeholder="$, cm, %, or biscuits")

    button.main.mt-4(v-if="!creatingKr" type="submit") Create key result
    button.main.mt-4(v-else @click.prevent)
      eva-icon.icon.text-indigo-3.spin.mr-2(name="loader-outline")
      | Creating key result...

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Resizable from "./Resizable";
import KeyResultListItem from "./KeyResultListItem";
import Modal from "../templates/Modal";
import DoughnutChart from "vue-doughnut-chart";
import Teams from "./Teams";
import Teammates from "./Teammates";
import UpdateCard from "./UpdateCard";

export default {
  props: ["index", "parentId", "parentType"],
  components: {
    Resizable,
    DoughnutChart,
    Modal,
    KeyResultListItem,
    Teams,
    Teammates,
    UpdateCard
  },
  data() {
    return {
      keyResult: null,
      keyResultError: null,
      empty: {
        targetValue: 100,
        initialValue: 0,
        teams: [],
        owners: [],
        title: "",
        description: "",
        status: "On track",
        cycle: "",
        nestedKeyResults: [],
        parent: "",
        unit: "",
        companyId: "",
        id: ""
      },
      creatingKr: false
    };
  },
  created() {
    this.setup();
  },
  computed: {
    ...mapGetters(["company", "profile", "keyResults", "objectives", "updates"])
  },
  methods: {
    ...mapActions(["blur", "select", "currentQuarter", "currentYear"]),
    async setup() {
      this.keyResult = this.empty;
      this.keyResult.parent = this.parentId;
      this.keyResult.companyId = this.profile.companyId;
      this.keyResult.cycle = `Q${await this.$store.dispatch(
        "currentQuarter"
      )} ${await this.$store.dispatch("currentYear")}`;
    },
    createKeyResult() {
      if (!this.keyResult.title) {
        this.keyResultError = "Please give your key result a title";
        return;
      } else {
        this.keyResultError = null;
      }
      if (!this.keyResult.initialValue) {
        this.keyResult.initialValue = 0;
      }
      if (!this.keyResult.targetValue) {
        this.keyResult.targetValue = 0;
      }

      this.creatingKr = true;

      const payload = {
        collection: "keyResults",
        item: this.keyResult
      };

      return this.$store.dispatch("createDoc", payload).then(doc => {
        heap.track("createKr");
        this.creatingKr = false;
        this.$store.dispatch("getKeyResults", this.profile.companyId);
        this.keyResult = this.empty;
        this.notify();
        this.$emit("close");
      });
    },
    notify() {
      this.$store.dispatch("fireNotification", {
        title: "Created Key Result!",
        type: "success"
      });
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  watch: {
    keyResultId() {
      this.setup();
    }
  }
};
</script>

<style lang="sass" scoped>
</style>
